export const PIN_HEADER_NO_PIN = 'Profile PIN'
export const PIN_HEADER_HAS_PIN = 'Profile PIN'

export const PIN_SUBHEADER_NO_PIN = 'Set up optional PIN protection in order to restrict switching between profiles or accessing profile settings. PIN protection can also be used for validating movie rental purchases.'
export const PIN_SUBHEADER_HAS_PIN = 'PIN protection has been setup. Click below to edit your PIN.'
export const PIN_SUBHEADER_EDITABLE = 'Update your PIN number below.'

export const PIN_CTA_NO_PIN = 'Set up PIN'
export const PIN_CTA_HAS_PIN = 'Change your PIN'
